(function() {
  'use strict';

  function ecCloseFiltersDrawer() {
    var toggle = document.getElementById('ec-filters-drawer-toggle');
    if (toggle) toggle.checked = false;
  }

  document.body.addEventListener('click', function (e) {
    if (e.target.closest('#ec-mobile-filters-done-btn')) {
      e.preventDefault();
      ecCloseFiltersDrawer();
      return;
    }
    var applyBtn = e.target.closest('#ec-mobile-apply-filters-btn');
    if (!applyBtn) return;
    var form = document.getElementById('FacetFiltersFormMobile');
    if (!form) return;
    var host = form.closest('facet-filters-form');
    if (!host || typeof host.createSearchParams !== 'function') return;
    e.preventDefault();
    var params = host.createSearchParams(form);
    if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) {
      FacetFiltersForm.renderPage(params, e);
    }
    ecCloseFiltersDrawer();
  });

  function ecParseLoadMoreDoc(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const grid = doc.getElementById('product-grid');
    if (grid) return { doc: doc, productGrid: grid };
    const sectionRoot = doc.querySelector('[id^="shopify-section"]');
    if (sectionRoot) {
      const nested = sectionRoot.querySelector('#product-grid');
      if (nested) return { doc: doc, productGrid: nested };
    }
    return { doc: doc, productGrid: null };
  }

  document.body.addEventListener('click', async function (e) {
    const btn = e.target.closest('.ec-collection__load-more-btn');
    if (!btn) return;

    e.preventDefault();

    const productGrid = document.getElementById('product-grid');
    const loadMoreContainer = document.getElementById('ec-load-more-container');
    if (!productGrid || !loadMoreContainer) return;

    const nextUrl = btn.dataset.nextUrl;
    if (!nextUrl || btn.classList.contains('loading')) return;

    btn.classList.add('loading');
    btn.disabled = true;

    try {
      const response = await fetch(nextUrl);
      if (!response.ok) throw new Error('Network response was not ok');

      const html = await response.text();
      const parsed = ecParseLoadMoreDoc(html);
      const newProductGrid = parsed.productGrid;

      if (newProductGrid) {
        const newProducts = newProductGrid.querySelectorAll('.ec-product-grid__item');
        newProducts.forEach(function (product, index) {
          product.style.opacity = '0';
          product.style.transform = 'translateY(20px)';
          productGrid.appendChild(product);

          requestAnimationFrame(function () {
            setTimeout(function () {
              product.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
              product.style.opacity = '1';
              product.style.transform = 'translateY(0)';
            }, index * 50);
          });
        });
      }

      const newLoadMoreBtn = parsed.doc.getElementById('ec-load-more-btn');
      if (newLoadMoreBtn && newLoadMoreBtn.dataset.nextUrl) {
        btn.dataset.nextUrl = newLoadMoreBtn.dataset.nextUrl;
        btn.dataset.currentPage = newLoadMoreBtn.dataset.currentPage;
        btn.classList.remove('loading');
        btn.disabled = false;
      } else {
        loadMoreContainer.innerHTML = '<p class="ec-collection__no-more">Todos os produtos foram carregados</p>';
      }
    } catch (error) {
      console.error('Error loading more products:', error);
      btn.classList.remove('loading');
      btn.disabled = false;
    }
  });

  const sidebar = document.querySelector('.ec-collection__sidebar');
  const filtersHeader = document.querySelector('.ec-collection__filters-header');
  
  if (sidebar && filtersHeader && window.innerWidth <= 749) {
    sidebar.classList.add('collapsed');
    filtersHeader.addEventListener('click', () => sidebar.classList.toggle('collapsed'));
    
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (window.innerWidth > 749) sidebar.classList.remove('collapsed');
      }, 250);
    });
  }

  const sortDropdowns = document.querySelectorAll('[data-sort-dropdown]');
  
  sortDropdowns.forEach(function(dropdown) {
    const btn = dropdown.querySelector('.ec-collection__sort-dropdown-btn');
    const menu = dropdown.querySelector('.ec-collection__sort-dropdown-menu');
    const options = dropdown.querySelectorAll('.ec-collection__sort-dropdown-option');
    let currentIndex = -1;
    
    function toggleDropdown() {
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        btn.setAttribute('aria-expanded', 'false');
        menu.setAttribute('hidden', '');
        currentIndex = -1;
      } else {
        btn.setAttribute('aria-expanded', 'true');
        menu.removeAttribute('hidden');
        currentIndex = Array.from(options).findIndex(opt => opt.hasAttribute('data-selected'));
        if (currentIndex === -1) currentIndex = 0;
        if (options[currentIndex]) options[currentIndex].focus();
      }
    }
    
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      toggleDropdown();
    });
    
    function handleKeydown(e) {
      if (e.key === 'Escape') {
        btn.setAttribute('aria-expanded', 'false');
        menu.setAttribute('hidden', '');
        btn.focus();
        currentIndex = -1;
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (btn.getAttribute('aria-expanded') === 'false') {
          toggleDropdown();
        } else {
          currentIndex = (currentIndex + 1) % options.length;
          if (options[currentIndex]) options[currentIndex].focus();
        }
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (btn.getAttribute('aria-expanded') === 'false') {
          toggleDropdown();
        } else {
          currentIndex = currentIndex <= 0 ? options.length - 1 : currentIndex - 1;
          if (options[currentIndex]) options[currentIndex].focus();
        }
      }
    }
    
    btn.addEventListener('keydown', handleKeydown);
    menu.addEventListener('keydown', handleKeydown);
    
    document.addEventListener('click', function(e) {
      if (!dropdown.contains(e.target)) {
        btn.setAttribute('aria-expanded', 'false');
        menu.setAttribute('hidden', '');
        currentIndex = -1;
      }
    });
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.classList || !t.classList.contains('ec-price-facet__bucket-input')) return;
    var card = t.closest('[data-price-facet-buckets]');
    if (!card) return;
    var form = t.closest('form');
    if (!form) return;
    var minHiddenInput = card.querySelector('[data-price-bucket-min]');
    var maxHiddenInput = card.querySelector('[data-price-bucket-max]');
    if (!minHiddenInput || !maxHiddenInput) return;

    function clearHiddens() {
      minHiddenInput.disabled = true;
      minHiddenInput.removeAttribute('value');
      maxHiddenInput.disabled = true;
      maxHiddenInput.removeAttribute('value');
    }

    function triggerFacetInput() {
      t.dispatchEvent(new Event('input', { bubbles: true }));
    }

    var allBuckets = Array.from(card.querySelectorAll('.ec-price-facet__bucket-input'))
      .sort(function (a, b) {
        return parseInt(a.getAttribute('data-price-bucket'), 10) - parseInt(b.getAttribute('data-price-bucket'), 10);
      });

    var checkedBuckets = allBuckets.filter(function (bucketInput) { return bucketInput.checked; });

    if (checkedBuckets.length === 0) {
      clearHiddens();
      triggerFacetInput();
      return;
    }

    var firstCheckedIndex = allBuckets.indexOf(checkedBuckets[0]);
    var lastCheckedIndex = allBuckets.indexOf(checkedBuckets[checkedBuckets.length - 1]);

    for (var i = firstCheckedIndex + 1; i < lastCheckedIndex; i++) {
      if (!allBuckets[i].checked) {
        allBuckets[i].checked = true;
        var inBetweenLabel = allBuckets[i].closest('.ec-facets__checkbox-label');
        if (inBetweenLabel) inBetweenLabel.classList.add('ec-facets__checkbox-label--checked');
      }
    }

    var firstBucket = allBuckets[firstCheckedIndex];
    var lastBucket = allBuckets[lastCheckedIndex];
    var minPrice = firstBucket.dataset.min || null;
    var maxPrice = lastBucket.dataset.max || null;

    if (minPrice === null) {
      minHiddenInput.disabled = true;
      minHiddenInput.value = '';
      minHiddenInput.removeAttribute('value');
    } else {
      minHiddenInput.disabled = false;
      minHiddenInput.value = minPrice;
    }

    if (maxPrice === null) {
      maxHiddenInput.disabled = true;
      maxHiddenInput.value = '';
      maxHiddenInput.removeAttribute('value');
    } else {
      maxHiddenInput.disabled = false;
      maxHiddenInput.value = maxPrice;
    }

    triggerFacetInput();
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.classList || !t.classList.contains('ec-facets__checkbox-input')) return;
    var label = t.closest('.ec-facets__checkbox-label');
    if (!label) return;
    if (t.checked) {
      label.classList.add('ec-facets__checkbox-label--checked');
    } else {
      label.classList.remove('ec-facets__checkbox-label--checked');
    }
  });

})();
